module.exports = __webpack_public_path__ + "img/BMC_ME_cover.8dc467b8.jpg";